import React from 'react';
import { Route, Routes } from 'react-router-dom';
import SaleEditPage from './SaleEditPage';
import SalesPage from './SalesPage';
import CustomersPage from './CustomersPage';
import CustomerPage from './CustomerPage';
import SaleItemsPage from './SaleItemsPage';
import SalePage from './SalePage';
import SendEmailPage from './SendEmailPage';
import RecurringInvoicesPage from './RecurringInvoicesPage';
import InvoiceSettingsPage from './InvoiceSettingsPage';
import RecurringSaleEditPage from './RecurringSaleEditPage';
import CustomerEditPage from "./CustomerEditPage";

const SaleRoutes: React.FC<any> = (props) => {
  return (
    <Routes>
      <Route path="customers" element={<CustomersPage/>}>
        <Route path="new" element={<CustomerEditPage isNew/>}/>
        {/*<Route path=":id/*" element={<CustomerPage />}/>*/}
        <Route path=":id/edit" element={<CustomerEditPage />}/>
      </Route>

      <Route path="items" element={<SaleItemsPage/>}/>

      <Route path="invoice-settings/*" element={<InvoiceSettingsPage/>}/>

      <Route path="/invoices" element={<SalesPage/>}/>
      <Route path="/invoices/new" element={<SaleEditPage isNew/>}/>
      <Route path="/invoices/:id/*" element={<SalePage/>}/>
      <Route path="/invoices/:id/edit" element={<SaleEditPage/>}/>

      <Route path="/recurring-invoices" element={<RecurringInvoicesPage/>}/>
      <Route path="/recurring-invoices/new" element={<RecurringSaleEditPage isNew/>}/>
      <Route path="/recurring-invoices/:id/*" element={<RecurringSaleEditPage />}/>
      <Route path="/recurring-invoices/:id/edit" element={<RecurringSaleEditPage/>}/>

      <Route path="*" element={<SalesPage/>}/>
  </Routes>
  );
};

export default SaleRoutes;
